let timeBack = 15;
const handleF = () => {
  const target = $
    ? $(
        ".ecom-collection__product-simple-add-to-cart, .ecom-product-single__add-to-cart--submit"
      )
    : null;
  if (target && target.length > 0) {
    $(
      ".ecom-collection__product-simple-add-to-cart, .ecom-product-single__add-to-cart--submit"
    ).on("click", () => {
      window.localStorage.setItem("neededRefreshCart", 1);
    });
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 200);
  }
};
handleF();

if (window.location.pathname.includes("/cart")) {
  if (window.localStorage.getItem("neededRefreshCart") > 0) {
    window.localStorage.setItem("neededRefreshCart", 0);
    setTimeout(() => {
      $("button.ecom-cart__product-quantity--button.ecom-quantity-plus").each(
        (index, target) => {
          $(target).on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.localStorage.setItem("clickedButton", "plus");
            window.localStorage.setItem("clickedButtonIndex", index);
            window.location.reload();
          });
        }
      );
      $("button.ecom-cart__product-quantity--button.ecom-quantity-minus").each(
        (index, target) => {
          $(target).on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.localStorage.setItem("clickedButton", "minus");
            window.localStorage.setItem("clickedButtonIndex", index);
            window.location.reload();
          });
        }
      );
      $(".ecom-cart__product-item-remove-button").each((index, target) => {
        $(target).on("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.localStorage.setItem("clickedButton", "remove");
          window.localStorage.setItem("clickedButtonIndex", index);
          window.location.reload();
        });
      });
    }, 1000);
  }

  if (window.localStorage.getItem("clickedButton") === "plus") {
    setTimeout(() => {
      window.localStorage.setItem("clickedButton", "none");
      $(
        "button.ecom-cart__product-quantity--button.ecom-quantity-plus:nth(" +
          window.localStorage.getItem("clickedButtonIndex") +
          ")"
      ).click();
    }, 3000);
  } else if (window.localStorage.getItem("clickedButton") === "minus") {
    setTimeout(() => {
      window.localStorage.setItem("clickedButton", "none");
      $(
        "button.ecom-cart__product-quantity--button.ecom-quantity-minus:nth(" +
          window.localStorage.getItem("clickedButtonIndex") +
          ")"
      ).click();
    }, 3000);
  } else if (window.localStorage.getItem("clickedButton") === "remove") {
    setTimeout(() => {
      window.localStorage.setItem("clickedButton", "none");
      window.location.href = $(
        ".ecom-cart__product-item-remove-button:nth(" +
          window.localStorage.getItem("clickedButtonIndex") +
          ")"
      ).attr("href");
    }, 3000);
  }
}

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;
document.addEventListener("done_render_qb_table", (event) => {
  if (
    pageType === "product" &&
    BSS_B2B &&
    BSS_B2B.qb &&
    BSS_B2B.qb.appliedQbRuleForOneProduct
  ) {
    const cartForm = document.querySelector("form[action='/cart/add']");
    const qbTable = cartForm.querySelector(".bss-b2b-qb-table");
    if (cartForm && !qbTable) {
      cartForm.insertAdjacentHTML(
        "afterbegin",
        '<div class="bss-b2b-qb-table"></div>'
      );
    }
  }
});
if (pageType === "cart" && BSS_B2B) {
  const maxWaitTime = 6000;
  const checkInterval = 100;
  let elapsedTime = 0;
  
  const intervalId = setInterval(() => {
    const target = document.querySelector('.cart-recap__checkout');
  
    if (target) {
        $(".cart-recap__checkout").before($(".bss-b2b-discount-code-wrapper"))
        $(".bss-b2b-discount-code-wrapper").css("opacity", "1")
        $(".cart-recap__checkout").before($(".bss-b2b-tax-ex-wrapper"))
        $(".bss-b2b-tax-ex-wrapper").css("opacity", "1")
      clearInterval(intervalId);
    }
  
    elapsedTime += checkInterval;
    if (elapsedTime >= maxWaitTime) {
      clearInterval(intervalId);
    }
  }, checkInterval);
  
  const cartItems = document.querySelectorAll(".ecom-cart__product-item");
  const buttonCheckout = document.querySelector(
    ".ecom-cart__checkout-button-container"
  );
  if (buttonCheckout) {
    const newCheckout = document.createElement("div");
    newCheckout.classList.add("bss-checkout");
    newCheckout.innerText = "Checkout";
    buttonCheckout.parentNode.replaceChild(newCheckout, buttonCheckout);
  }
  if (cartItems && cartItems.length) {
    cartItems.forEach((cartItem) => {
      const cartItemKeyEle = cartItem.querySelector(
        ".ecom-cart__product-item input[data-key]"
      );
      const cartItemKey = cartItemKeyEle?.getAttribute("data-key");
      cartItem.setAttribute("data-cart-item-key", cartItemKey);
    });
  }
}

setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.className === 'bss-b2b-cart-with-vat-price') {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)

const elementsToggle = document.querySelectorAll(".vat-toggle");
if(window.screen.availWidth > 750) elementsToggle[0].remove();
const toggle = document.getElementById("vatToggle");
const text = document.getElementById("vatText");
const check = localStorage.getItem("toggle-bss-checked") === "true" || localStorage.getItem("toggle-bss-checked") === null;
if(check) {
  text.textContent = "Inc VAT";
  toggle.checked = true;
}
toggle.addEventListener("change", () => {
  text.textContent = toggle.checked ? "Inc VAT" : "Ex VAT";
  localStorage.setItem("toggle-bss-checked", toggle.checked ? "true":"false");
});